import * as angular from "angular";
import {PlanProjectEntity} from "../models/plan-project-entity.model";
import {IQService} from "angular";
import {PlanningAlertsService} from "./planning-alerts.service";
import {PlanningRequestsService} from "./planning-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {RouteSwapResourceRequestModel} from "../models/route-swap-resource-request.model";
import {AddressQualityEnum} from "../../addresses/types/address-quality.enum";
import {SchedulingSmsStatusEnum} from "../../oms/types/scheduling-sms-status.enum";


export class PlanningProjectsService {

  private _loading: {
    enabled: boolean
  };

  constructor(private planningRequestsService: PlanningRequestsService,
              private planningAlertsService: PlanningAlertsService,
              private planningConstants,
              private $state, private $q: IQService, private bringozLoaderService: BringozLoaderService, private $log) {
    this._loading = {
      enabled: false
    }
  }

  public get getLoading() {
    return this._loading;
  }

  public getProjects(from, to, branchIds) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.getProjects(from, to, branchIds)
      .then((projects) => {
        deferred.resolve(projects)
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.getProjectsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }


  public createProject(project: PlanProjectEntity) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.createProject(project)
      .then((createdProject) => {
        this.planningAlertsService.createProjectSuccess();
        deferred.resolve(createdProject)
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.createProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  createProjectWithFulfillments(payload) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.createProjectWithFulfillments(payload)
      .then((createdProject) => {
        this.planningAlertsService.createProjectSuccess();
        deferred.resolve(createdProject)
      })
      .catch((error) => {
        this.planningAlertsService.createProjectError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise

  }

  public deleteProject(projectId) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.deleteProject(projectId)
      .then((deletedProject) => {
        this.planningAlertsService.deleteProjectSuccess();
        deferred.resolve(deletedProject)
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.deleteProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public getProject(id, reason) {
    const deferred = this.$q.defer();

    this.planningRequestsService.getProject(id)
      .then((project) => {
        if (reason && reason === 'ADD_JOBS')
          this.planningAlertsService.addJobToProjectSuccess();

        deferred.resolve(project)
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      });

    return deferred.promise
  }

  public getJobs(projectId) {
    const deferred = this.$q.defer();

    this.planningRequestsService.getProjectJobs(projectId)
      .then((jobs) => {
        deferred.resolve(jobs)
      })
      .catch((error) => {
        this.planningAlertsService.addJobToProjectError();
        this.$log.error(error);
        deferred.reject(error)
      });

    return deferred.promise
  }

  getResources(projectId) {
    const deferred = this.$q.defer();

    this.planningRequestsService.getProjectResources(projectId)
      .then((resources) => {
        deferred.resolve(resources)
      })
      .catch((error) => {
        this.planningAlertsService.addResourcesToProjectSuccess();
        this.$log.error(error);
        deferred.reject(error)
      });

    return deferred.promise
  }

  public getDepots(projectId) {
    const deferred = this.$q.defer();

    this.planningRequestsService.getProjectDepots(projectId)
      .then((project) => {
        deferred.resolve(project)
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      });

    return deferred.promise
  }

  public addJobs(jobs, project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addJobsToProject(jobs, project.id)
      .then((jobsCreated) => {
        this.planningAlertsService.addJobToProjectSuccess();
        deferred.resolve(jobsCreated);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.addJobToProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  setSelectedDraft(projectId, draftId) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.selectDraftInProject(projectId, draftId)
      .then((draft) => {
        deferred.resolve(draft)
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.createDraftInProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public updateJob(job, project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.updateJobInProject(job, project.id)
      .then((updatedJob) => {
        this.planningAlertsService.updateJobInProjectSuccess();
        deferred.resolve(updatedJob);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.updateJobInProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public deleteJobs(jobIds, project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.deleteJobsFromProject(jobIds, project.id)
      .then((deletedJobIds) => {
        this.planningAlertsService.deleteJobFromProjectSuccess();
        deferred.resolve(deletedJobIds);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.deleteJobFromProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public addOrders(payload, projectId) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addOrdersToProject(payload, projectId)
      .then((ordersAdded) => {
        // PlanningAlerts.addOrdersToProjectSuccess();
        deferred.resolve(ordersAdded);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.addOrdersToProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public addServices(payload, projectId: string) {

    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addServicesToProject(payload, projectId)
      .then((jobs) => {
        // PlanningAlerts.addServicesToProjectSuccess();
        deferred.resolve(jobs);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public addAbortedServices(payload, projectId: string) {

    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addAbortedServicesToProject(payload, projectId)
      .then((jobs) => {
        deferred.resolve(jobs);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public addSteps(from, to, statuses, branchIds, accountIds, serviceAreaIds,
                  attempts, tagNames, schedulingRequired, project) {

    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addStepsToProject(from, to, statuses, branchIds, accountIds, serviceAreaIds,
      attempts, tagNames, schedulingRequired, project.id)
      .then((jobs) => {
        // PlanningAlerts.addServicesToProjectSuccess();
        deferred.resolve(jobs);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public addFulfillments(FulfillmentExtFilter, projectId) {

    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addFulfillmentsToProject(FulfillmentExtFilter, projectId)
      .then((jobs) => {
        this.planningAlertsService.addStepsToProjectSuccess();
        deferred.resolve(jobs);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.addStepsToProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  addResources(resources, project, importAllocationResourcesServiceTemplate?: boolean) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addResourcesToProject(resources, project.id, importAllocationResourcesServiceTemplate)
      .then((resourcesAdded) => {
        this.planningAlertsService.addResourcesToProjectSuccess();
        deferred.resolve(resourcesAdded);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.addResourcesToProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public addDepots(depots, project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.addDepotsToProject(depots, project.id)
      .then((depotsAdded) => {
        this.planningAlertsService.addDepotsToProjectSuccess();
        deferred.resolve(depotsAdded);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.addDepotsToProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  deleteResources(resourceIds, project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.deleteResourcesFromProject(resourceIds, project.id)
      .then((deletedResourceIds) => {
        this.planningAlertsService.deleteResourcesFromProjectSuccess();
        deferred.resolve(deletedResourceIds);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.deleteResourcesFromProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  deleteDepots(depotIds, project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.deleteResourcesFromProject(depotIds, project.id)
      .then((deletedDepotIds) => {
        this.planningAlertsService.deleteDepotsFromProjectSuccess();
        deferred.resolve(deletedDepotIds);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.deleteDepotsFromProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  updateProjectDetails(project) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.updateProjectDetails(project, project.id)
      .then((updatedProject) => {
        this.planningAlertsService.updateProjectDetailsSuccess();
        deferred.resolve(updatedProject);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.updateProjectDetailsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public updateProjectSettings(settings, projectId) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.updateProjectSettings(settings, projectId)
      .then((updatedSettings) => {
        this.planningAlertsService.updateProjectSettingsSuccess();
        deferred.resolve(updatedSettings);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.updateProjectSettingsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public createProjectWithOrders(project, ids, excludedIds, statuses, partiallyScheduled, from, to, branchIds, accountIds,
                                 serviceAreaIds, tagNames, isNotTag, attempts, isPacked, filterByCreatedAt, displayStatus,
                                 schedulingRequired, obligateTimeWindow, noFromLocation, noToLocation, programTypes: string[], addressQualityGroup: AddressQualityEnum[], schedulingSmsStatuses?: SchedulingSmsStatusEnum[], pickupDepotIds?: string[], destinationDepotIds?: string[], depotIds?: string[], searchTerm?: string, noArea?: boolean) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.createProjectWithOrders(project, ids, excludedIds, statuses, partiallyScheduled, from, to, branchIds, accountIds,
      serviceAreaIds, tagNames, isNotTag, attempts, isPacked, filterByCreatedAt, displayStatus,
      schedulingRequired, obligateTimeWindow, noFromLocation, noToLocation, programTypes, addressQualityGroup, schedulingSmsStatuses, pickupDepotIds, destinationDepotIds, depotIds, searchTerm, noArea)
      .then((result) => {
        this.planningAlertsService.createProjectSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.createProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public servicePlanning(serviceIds?: string[], routeIds?: string[], settings?, resources?, reOptimize?: boolean, takeResourcesFromRoute?: boolean) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.servicePlanning(serviceIds, routeIds, settings, resources, reOptimize, takeResourcesFromRoute)
      .then((res) => {
        this.planningAlertsService.createProjectSuccess(res.planProject, true)
          .then((goToView) => {
            if (goToView) {
              this.$state.go(this.planningConstants.states.project, {projectId: res.planProject.id});
            }
          });
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.createProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  public getMonitoring(from: number, to: number, branchIds?: string[]) {
    const deferred = this.$q.defer();

    // this.setLoading(true);
    this.planningRequestsService.getMonitoring(from, to, branchIds)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
    // .finally(() => {
    //   this.setLoading(false);
    // });

    return deferred.promise
  }

  importJobsIntoProject(projectId: string, filePreview) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.importJobsIntoProject(projectId, filePreview)
      .then((res) => {
        this.planningAlertsService.importJobsIntoProjectSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.planningAlertsService.importJobsIntoProjectError();
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  toggleObligateTimeWindow(projectId: string, draftId: string, draftJobIds: string[], obligateTimeWindow: boolean) {
    const deferred = this.$q.defer();

    this.setLoading(true);
    this.planningRequestsService.toggleObligateTimeWindow(projectId, draftId, draftJobIds, obligateTimeWindow)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.setLoading(false);
      });

    return deferred.promise
  }

  // ******************************
  //        Private methods
  // ******************************


  private setLoading(isActive) {
    if (isActive) {
      this._loading.enabled = true;
      this.bringozLoaderService.on();
    } else {
      this._loading.enabled = false;
      this.bringozLoaderService.off();
    }
  }


}

angular
  .module('bringoz.admin.planning')
  .service('planningProjectsService', PlanningProjectsService);
